import { render, staticRenderFns } from "./DepartmentsList.vue?vue&type=template&id=217c302e&"
import script from "./DepartmentsList.vue?vue&type=script&lang=js&"
export * from "./DepartmentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports